import { createUseFeatureFlag, type FlagValues } from "@src/featureFlags";

// When adding a new feature flag or variant, type must be defined here

const FeatureFlags = {
  "demo-features": ["off", "on"],
  "decarb-planning": ["off", "v1"],
  "inactive-sites": ["off", "on"],
  // Editing equipment in staging can edit data in airtable and production.
  // Disabling requests in staging by default as an additional safety measure.
  // Fake equipment has been created under the Bractlet HQ site (Site ID 185). These equipment are safe to test edits in staging.
  "UNSAFE_enable-dangerous-equipment-edit": ["off", "on"],
  "role-based-permissions": ["off", "v1"],
  "equipment-export-all-data": ["off", "v1"],
  // "admin" is a semi-permanent flag value that enables a UX for assigning existing office structures UBIN™ related fields
  // it will have no effect when assigned to non-super admin users as the UX will also be gated by a super admin check
  // the "on" variant of this flag has been rolled out
  "building-level-ubin-office": ["off", "admin"],
  // Allows linking an existing document to multiple equipment (requires INNO-2039 BE work)
  "equipment-link-document": ["off", "v1"],
  // Server-side pagination for Site Equipment page (INNO-2632)
  "site-equipment-pagination": ["off", "v1"],
  // Portfolio-level async equipment CSV export (INNO-2747)
  "portfolio-equipment-csv-export": ["off", "v1"],
  // Space notes in the T&S side drawer
  "space-notes": ["off", "v1"],
  // Read-only per-feature permissions matrix on My Profile, the user screen and the
  // Add New User wizard (INNO-2888)
  "rbac-permissions-summary": ["off", "v1"],
  "eliminate-two-way-sync": ["off", "on"],
  "equipment-photo-export": ["off", "v1"],
  "auth-design-refresh": ["off", "v1"],
  "rebates-inactive-sites": ["off", "on"],
} as const;

export type FeatureFlagsType = FlagValues<typeof FeatureFlags>;

export const useFeatureFlag = createUseFeatureFlag<typeof FeatureFlags>();

export { FeatureFlags };
